export default __webpack_public_path__ + "static/media/HDTX_Ringkasan Risalah RUPS 30 Juni 2025.859adae0.pdf";